import React from 'react'
import { Link } from '@sitecore-jss/sitecore-jss-react'
import { GenericCTAListProps } from './types/GenericCTAList.types'
import { GenericCTAListModel } from './models/GenericCTAList.model'
import './index.scss'
import '../SplitModule/index.scss'
import '../TextModule/index.scss'

const GenericCTAList = (props: GenericCTAListProps) => {
  const model = new GenericCTAListModel(props)
  const array = model?.list

  const numberOfRows = Math.ceil(array.length / 4)
  const rows = [...Array(numberOfRows)]
  const elementRows = rows.map((row, idx) => array.slice(idx * 4, idx * 4 + 4))

  return (
    <div id={props.rendering?.uid}>
      {model?.title && (
        <span className="generic-cta-wrapper text-module__title text-module__ttlB">
          {model?.title}
        </span>
      )}
      <div className="generic-cta-wrapper generic-cta-wrapper-parent">
        {elementRows.map((row, i) => {
          return (
            <div
              key={i}
              className={`${
                row.length < 4
                  ? 'generic-cta-wrapper-left'
                  : 'generic-cta-wrapper-child'
              }`}
            >
              {row.map((innerElem, ind) => (
                <div
                  key={ind}
                  className={'split-module__text__buttons generic-cta-overflow'}
                >
                  <div
                    className={`split-module__text__primary-link cta cta2 ${
                      model?.variant === 'v1' && 'cta-primary-red'
                    } ${model?.variant === 'v2' && 'cta-primary-offwhite'} ${
                      model?.variant === 'v3' && 'cta-primary-red2'
                    } ${model?.variant === 'v4' && 'cta-primary-black'} ${
                      model?.variant === 'v5' && 'cta-primary-white'
                    } ${model?.variant === 'v6' && 'cta-primary-white2'} ${
                      model?.variant === 'v7' && 'cta-primary-offwhitered'
                    } ${
                      (model?.variant === '' || !model?.variant) &&
                      'cta-primary-red'
                    } generic-cta-hun"`}
                  >
                    <Link
                      field={innerElem?.fields?.Link as any}
                      className="generic-cta-button"
                    />
                  </div>
                </div>
              ))}
            </div>
          )
        })}
      </div>
      {!model?.title && <div className="box-divider"></div>}
    </div>
  )
}

export default GenericCTAList
